import React, { useRef } from 'react'
import { Bar } from 'react-chartjs-2'
import { Divider, Grid, Paper, Typography } from '@mui/material'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import RYGGLegend from '../adminreport/RYGGLegend'
/** 
 * 
 * This component is expecting the following input. it will iterate through the BarChart section
{
    "Order": "50",
    "Visible": "1",
    "Label": "",
    "ComponentType": "KEY AREA CHART",
    "BarChart": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "HEART",
            "Score": "58",
            "ValueGrade": "2"
        }
    ]
}
*/

const AdminKeyAreaGraph = (props) => {
    const FilteredSections = [...props.component.Sections].filter((a) => { return a.Visible === '1' })
    const OrderedSections = FilteredSections.sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })
    const chartRef = useRef(null);
    let graphcolors = ['#4eb748', '#E7C61E', '#9A3218', '#c0c0c0']
    const motionVariants = {
        hidden: { opacity: 0, x: 0, y: 0 },
        show: {
            opacity: 1, x: 0, y: 0,
            transition: {
                delay: 0.1,
                duration: 0.5,
            }
        }
    }
    /**
     * Chart JS DataSets are weird.
     * Each DataSet is a valuegrade, essentially.
     * each label is an array of labels
     * each data is an array of datasets
     * so we need to take Heart [{1}, {2}, {3}], Cancer [{1}, {2}, {3}]
     * and convert it into 
     *      dataset 1: labels:  data: [heart cancer]
     *      dataset 2: labels:  data: [heart cancer]
     *      dataset 3: labels:  data: [heart cancer]
     *      dataset 4: labels:  data: [heart cancer]
     */

    const mapLabels = OrderedSections.map((x, i) => {
        return x.Label
    })

    const mapData_1 = OrderedSections.map((x, i) => {
        const Values = [...OrderedSections[i].Values].sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })
        return Values[0].Distribution
    })

    const mapData_2 = OrderedSections.map((x, i) => {
        const Values = [...OrderedSections[i].Values].sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })
        return Values[1].Distribution
    })

    const mapData_3 = OrderedSections.map((x, i) => {
        const Values = [...OrderedSections[i].Values].sort((a, b) => { return parseInt(a.Order) - parseInt(b.Order) })
        return Values[2].Distribution
    })

    const dsets = [
        {
            label: ['LOW']
            , data: mapData_1
            , backgroundColor: ['#209D70']
        },
        {
            label: ['MEDIUM']
            , data: mapData_2
            , backgroundColor: ['#FEC957']

        },
        {
            label: ['HIGH']
            , data: mapData_3
            , backgroundColor: ['#E6323A']

        }
    ]


    const data = {
        labels: mapLabels,
        datasets: dsets,
    }

    const config = {
        type: 'bar',
        data: data,
        options: {
            //indexAxis: 'y',
            maintainAspectRatio: false,
            scales: {
                y: {
                    beginAtZero: true,
                    stacked: true,
                    max: 100,
                    grid: {
                        display: true
                        , drawBorder: true  //turns off border lines

                    },
                    ticks: {
                        stepSize: 20
                        , display: true
                    }
                },
                x: {
                    grid: {
                        display: true
                        , drawBorder: true  //turns off border lines

                    }
                    , ticks: {
                        display: true
                    }
                    , stacked: true
                }
            },
            plugins: {
                legend: {
                    display: false
                }
            },

        }
    }

    return (
        <Grid item lg={12} md={12} sm={12} xs={12} justifyContent="center" alignItems="center" sx={{ padding: '10px' }}>
            <motion.div variants={motionVariants} initial="hidden" animate="show" style={{ height: '100%' }}>
                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>

                    <Grid item xs={12}>
                        <Typography variant='h4' align="center">
                            Key Areas
                        </Typography>
                    </Grid>


                    <Grid item xs={12} m={1}>
                        <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
                    </Grid>

                    <Grid item xs={12}>
                        <Paper elevation={props.elevationdisabled === true ? 0 : 1} sx={{ padding: '40px', minHeight: "400px" }}>
                            <Bar
                                ref={chartRef}
                                data={data}
                                options={config.options}
                            //onClick={handleScrollToSection}
                            />

                        </Paper>
                    </Grid>
                    <Grid item xs={12}>
                        <RYGGLegend />
                    </Grid>
                </Grid>
            </motion.div>
        </Grid>
    )
}

export default AdminKeyAreaGraph